function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';
import { AdaptiveListener, EdgeDetection } from 'xps-react-utils';
import ClickListener from '../utils/ClickListener';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/popover.css');

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.viewingFlag('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.viewingFlag('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.viewingFlag('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "doEdgeDetection", function () {
      var _this$state = _this.state,
          useOverflowWidth = _this$state.useOverflowWidth,
          viewingExperience = _this$state.viewingExperience;
      var overflows = EdgeDetection.detect(EdgeDetection.getDimensions(_this.popoverNode), EdgeDetection.getWindowDimensions());

      if (overflows.length && viewingExperience === 'mobile' && useOverflowWidth === false) {
        _this.setState({
          direction: 'top',
          useOverflowWidth: true
        }, function () {
          return _this.updateBoundingRect();
        });
      }

      return {
        newPosition: null
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateAriaHiddenState", function (value) {
      return _this.setState({
        ariaHidden: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      var ariaHidden = _this.state.ariaHidden;

      switch (e.key) {
        case ' ':
          return _this.updateAriaHiddenState(!ariaHidden);

        case 'Enter':
          return _this.updateAriaHiddenState(!ariaHidden);

        case 'Escape':
          return _this.updateAriaHiddenState(true);

        default:
          return false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "viewingFlag", function (flag) {
      _this.setState({
        viewingExperience: flag
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (content) {
      var _this$props = _this.props,
          width = _this$props.width,
          overflowWidth = _this$props.overflowWidth;
      var _this$state2 = _this.state,
          useOverflowWidth = _this$state2.useOverflowWidth,
          viewingExperience = _this$state2.viewingExperience;
      var contentWidth = {
        width: 'auto',
        whiteSpace: 'nowrap'
      };

      if (width && !useOverflowWidth) {
        contentWidth = {
          width: width
        };
      } else if (useOverflowWidth && viewingExperience === 'mobile') {
        contentWidth = {
          width: window.innerWidth - 66,
          marginLeft: 'auto',
          marginRight: 'auto'
        };
      } else if (useOverflowWidth) {
        contentWidth = {
          width: overflowWidth
        };
      }

      if (typeof content === 'function') {
        return /*#__PURE__*/React.createElement("div", {
          style: contentWidth
        }, content());
      } else {
        return /*#__PURE__*/React.createElement("div", {
          style: contentWidth
        }, content);
      }
    });

    _this.state = {
      ariaHidden: true,
      direction: props.direction,
      checkOverflow: props.overflowDirection !== null,
      useOverflowWidth: false,
      popoverPosition: {
        top: 0,
        left: 0
      },
      viewingExperience: 'mobile'
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBoundingRect();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props2 = this.props,
          overflowDirection = _this$props2.overflowDirection,
          overflowWidth = _this$props2.overflowWidth;
      var _this$state3 = this.state,
          ariaHidden = _this$state3.ariaHidden,
          checkOverflow = _this$state3.checkOverflow,
          viewingExperience = _this$state3.viewingExperience;

      if (viewingExperience !== 'mobile' && checkOverflow) {
        var overflows = EdgeDetection.detect(EdgeDetection.getDimensions(this.popoverNode), EdgeDetection.getWindowDimensions());

        if (overflows.length) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            direction: overflowDirection,
            checkOverflow: false,
            useOverflowWidth: overflowWidth !== null
          }, function () {
            _this2.updateBoundingRect();
          });
        }
      }

      if (!ariaHidden && prevState.ariaHidden !== ariaHidden) {
        this.updateBoundingRect();
      }
    }
  }, {
    key: "updateBoundingRect",
    value: function updateBoundingRect() {
      var arrowOffset = 12;
      var _this$state4 = this.state,
          direction = _this$state4.direction,
          viewingExperience = _this$state4.viewingExperience,
          useOverflowWidth = _this$state4.useOverflowWidth;
      var popover = this.popoverNode;
      var container = this.containerNode;
      var dynamicOffset = -container.getBoundingClientRect().left + 16;
      var popoverPosition;
      var overflowCheck = EdgeDetection.detect(EdgeDetection.getDimensions(popover), EdgeDetection.getWindowDimensions());

      if (overflowCheck.length && viewingExperience === 'mobile' || useOverflowWidth === true && viewingExperience === 'mobile') {
        popoverPosition = {
          left: dynamicOffset,
          bottom: container.offsetHeight + arrowOffset,
          marginLeft: 'auto',
          marginRight: 'auto'
        };
      } else if (direction === 'top') {
        popoverPosition = {
          bottom: container.offsetHeight + arrowOffset,
          left: container.offsetWidth / 2 - popover.offsetWidth / 2
        };
      } else if (direction === 'bottom') {
        popoverPosition = {
          top: container.offsetHeight + arrowOffset,
          left: container.offsetWidth / 2 - popover.offsetWidth / 2
        };
      } else if (direction === 'left') {
        popoverPosition = {
          top: container.offsetHeight / 2 - popover.offsetHeight / 2,
          left: 0 - (popover.offsetWidth + arrowOffset)
        };
      } else if (direction === 'right') {
        popoverPosition = {
          top: container.offsetHeight / 2 - popover.offsetHeight / 2,
          right: 0 - (popover.offsetWidth + arrowOffset)
        };
      }

      this.doEdgeDetection(popoverPosition);
      if (typeof popoverPosition === 'undefined') return false;

      if (popoverPosition.left < 0 && viewingExperience === 'mobile' || direction === 'right' && popover.getBoundingClientRect().width + popover.getBoundingClientRect().right > window.innerWidth && viewingExperience === 'mobile') {
        popoverPosition = {
          left: dynamicOffset,
          bottom: container.offsetHeight + arrowOffset,
          marginLeft: 'auto',
          marginRight: 'auto'
        };
        return this.setState({
          popoverPosition: popoverPosition,
          useOverflowWidth: true
        });
      }

      return this.setState({
        popoverPosition: popoverPosition
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          content = _this$props3.content,
          id = _this$props3.id,
          error = _this$props3.error,
          warning = _this$props3.warning,
          arrow = _this$props3.arrow,
          className = _this$props3.className;
      var _this$state5 = this.state,
          ariaHidden = _this$state5.ariaHidden,
          direction = _this$state5.direction,
          popoverPosition = _this$state5.popoverPosition,
          viewingExperience = _this$state5.viewingExperience;
      var popoverProps = getValidElementProps('div', this.props);
      this.ntClass = cx({
        popoverContainer__popover: true,
        'position-absolute': true,
        'display-none': ariaHidden,
        'display-block': !ariaHidden,
        'popover-skin--primary': !error && !warning,
        'popover-skin--error': error,
        'popover-skin--warning': warning,
        'popover__arrow--bottom': direction === 'top' && arrow === true && viewingExperience !== 'mobile',
        'popover__arrow--top': direction === 'bottom' && arrow === true && viewingExperience !== 'mobile',
        'popover__arrow--left': direction === 'right' && arrow === true && viewingExperience !== 'mobile',
        'popover__arrow--right': direction === 'left' && arrow === true && viewingExperience !== 'mobile'
      }, className);
      return /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, /*#__PURE__*/React.createElement(ClickListener, {
        onClickOutside: function onClickOutside(e) {
          return _this3.updateAriaHiddenState(true, e);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "popoverContainer",
        ref: function ref(node) {
          _this3.containerNode = node;
        },
        onMouseEnter: function onMouseEnter() {
          return _this3.updateAriaHiddenState(false);
        },
        onFocus: function onFocus() {
          return _this3.updateAriaHiddenState(false);
        },
        onMouseLeave: function onMouseLeave() {
          return _this3.updateAriaHiddenState(true);
        },
        onBlur: function onBlur() {
          return _this3.updateAriaHiddenState(true);
        },
        onKeyPress: function onKeyPress(e) {
          return _this3.handleKeyPress(e);
        },
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("div", _extends({
        className: this.ntClass,
        role: "tooltip",
        id: id,
        ref: function ref(node) {
          _this3.popoverNode = node;
        },
        style: popoverPosition,
        "aria-hidden": ariaHidden
      }, popoverProps), /*#__PURE__*/React.createElement("div", {
        className: "popover__content"
      }, this.renderContent(content))), /*#__PURE__*/React.createElement("div", {
        className: "display-inlineblock"
      }, children))));
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "propTypes", {
  children: PropTypes.node.isRequired,

  /** Content of the popover. You can put simple text, any html tags, function, or any other components */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.any,

  /** Direction of the popover to show up: ["top", "bottom", "left", or "right"] */
  direction: PropTypes.string,

  /** Secondary direction of popover if content overflows screen (see `direction`) */
  overflowDirection: PropTypes.string,

  /** whether the popover should have arrow or not */
  arrow: PropTypes.bool,
  id: PropTypes.string.isRequired,

  /** Error/negative popover */
  error: PropTypes.bool,

  /** Warning popover */
  warning: PropTypes.bool,

  /** Add inline width styling for content as string, ie: "100px" or 100 */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Add inline width styling for content as string for overflow direction, ie: "100px" or 100 */
  overflowWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

_defineProperty(Popover, "defaultProps", {
  direction: 'top',
  overflowDirection: null,
  overflowWidth: null,
  arrow: true,
  error: false,
  warning: false
});

Popover.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "doEdgeDetection",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateAriaHiddenState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleKeyPress",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "viewingFlag",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "flag",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateBoundingRect",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderContent",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "content",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Popover",
  "props": {
    "direction": {
      "defaultValue": {
        "value": "'top'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Direction of the popover to show up: [\"top\", \"bottom\", \"left\", or \"right\"]"
    },
    "overflowDirection": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Secondary direction of popover if content overflows screen (see `direction`)"
    },
    "overflowWidth": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Add inline width styling for content as string for overflow direction, ie: \"100px\" or 100"
    },
    "arrow": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "whether the popover should have arrow or not"
    },
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Error/negative popover"
    },
    "warning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Warning popover"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "content": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": true,
      "description": "Content of the popover. You can put simple text, any html tags, function, or any other components"
    },
    "className": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "width": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Add inline width styling for content as string, ie: \"100px\" or 100"
    }
  }
};
export default Popover;